import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rlst-pagination',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaginationComponent {
  @Input() public currentPageNumber: number = 1;
  @Input() public totalPages: number;
  @Output() public previousClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() public nextClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() public pageNumberChanged: EventEmitter<number> = new EventEmitter<number>();

  public changePageNumber(event: KeyboardEvent): void {
    const changedPageNumber: number = Number((event.target as HTMLInputElement).value);
    if(!changedPageNumber) return;
    if(changedPageNumber > 0 && changedPageNumber <= this.totalPages) {
      this.pageNumberChanged.emit(changedPageNumber);
    }
  }
}
